import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PencilLineOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PencilLineOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M21.5 2.015a3.495 3.495 0 0 1 0 4.95L9.49 18.975l-4.99.04v-5l12.05-12a3.5 3.5 0 0 1 2.48-1.03c.89 0 1.79.35 2.47 1.03Zm-2.48.97c-.4 0-.78.16-1.06.44v.01l-1.57 1.56 2.12 2.12 1.57-1.57c.58-.58.58-1.54 0-2.12-.28-.28-.66-.44-1.06-.44ZM6.5 14.845v2.15l.01.01 2.15-.02 8.45-8.45-2.13-2.13-8.48 8.44Z" />
          <path d="M0 21.015h24v2H0v-2Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default PencilLineOutlined;